import { Box, Card, Typography, Switch, TextField, MenuItem, Button, Chip, IconButton, Stack, List, ListItem, ListItemIcon, ListItemText, Avatar, Grid, TableContainer, TableBody, Table, TableCell, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { LocationOn, FileDownload, Fullscreen, FilterListAlt, Visibility, PowerSettingsNew, Sync, BugReport, SystemUpdateAlt, BatteryFull, Opacity, DeviceThermostat } from '@mui/icons-material';


function Diagnostics() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isMobile]);

    const [autoRefresh, setAutoRefresh] = useState(false);
    const [selectDevice, setSelectDevice] = useState("Select Device");
    const [time, setTime] = useState("Time Range");


    const sensorData = [
        {
            title: "Temperature",
            value: "23.5°C",
            delta: "+0.3°C",
            deltaColor: "success.main",
            bg: "#f0f7ff",
            icon: <DeviceThermostat />,
        },
        {
            title: "Humidity",
            value: "67%",
            delta: "-2%",
            deltaColor: "error.main",
            bg: "#f8f2ff",
            icon: <Opacity />,
        },
        {
            title: "Battery Level",
            value: "87%",
            delta: "-1%",
            deltaColor: "error.main",
            bg: "#fff6e9",
            icon: <BatteryFull />,
        },
    ];

    const actionData = [
        {
            title: "Restart Device",
            desc: "Perform a soft restart",
            icon: <PowerSettingsNew color="primary" />,
        },
        {
            title: "Sync Configuration",
            desc: "Update device settings",
            icon: <Sync color="success" />,
        },
        {
            title: "Run Diagnostics",
            desc: "Execute health check",
            icon: <BugReport color="secondary" />,
        },
        {
            title: "Force Update",
            desc: "Push firmware update",
            icon: <SystemUpdateAlt color="warning" />,
        },
    ];


    const SensorItem = ({ icon, title, value, delta, deltaColor, bg }) => (
        <Box sx={{ bgcolor: bg, p: 2, borderRadius: 3, mb: 2 }}>
            <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" spacing={0.1} alignItems="left">
                    {icon}
                    <Typography>{title}</Typography>
                </Stack>
                <Typography fontSize={12} color="text.secondary">
                    Updated 2s ago
                </Typography>
            </Stack>

            <Stack direction="row" justifyContent="space-between" mt={1}>
                <Typography fontSize={24} fontWeight={700}>
                    {value}
                </Typography>
                <Typography sx={{ color: deltaColor }}>{delta}</Typography>
            </Stack>
        </Box>
    );

    const ActionItem = ({ icon, title, desc, last }) => (
        <ListItem
            sx={{
                border: "1px solid #e5e7eb",
                borderRadius: 3,
                mb: last ? 0 : 2,
            }}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText
                primary={title}
                secondary={desc}
                primaryTypographyProps={{ fontWeight: 600 }}
            />
        </ListItem>
    );


    const logs = [
        {
            timestamp: "2024-01-15 14:32:15",
            type: "Sync Configuration",
            icon: <Sync color="primary" />,
            user: "admin@iot.com",
            status: "Success",
            color: "green",
            ResponseTime: "1.2s",
        },
        {
            timestamp: "2024-01-15 13:45:08",
            type: "Restart Device",
            icon: <PowerSettingsNew color="primary" />,
            user: "admin@iot.com",
            status: "",
            ResponseTime: "",
        },
    ];

    return (
        <Box p={isMobile ? 1: 3} mt={isMobile ? "2rem" : 0}>
            <Card sx={{ mt: 3, borderRadius: "16px", width:"100%"}}>
                <Box display="flex" flexWrap="wrap" justifyContent="space-between" p={2}>
                    <Typography variant="h5" fontWeight={600}>
                        Device Selection
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h6" fontWeight={300}>
                            Auto-refresh:
                        </Typography>

                        <Switch
                            checked={autoRefresh}
                            onChange={(e) => setAutoRefresh(e.target.checked)}
                            color="primary"
                        />
                    </Box>

                </Box>

                <Box
                    px={2}
                    py={1.5}
                    display="flex"
                    flexWrap="wrap"          // ✅ correct
                    rowGap={1}
                    columnGap={2}
                    alignItems="center"
                    justifyContent="flex-start"
                // borderBottom="1px solid #e5e7eb"
                >
                    <TextField select value={selectDevice} onChange={(e) => setSelectDevice(e.target.value)} style={{ width: isMobile ? "300px" : "200px", marginRight: isMobile ? "0.6rem" : "" }}>
                        <MenuItem value="Select Device" >Select Device</MenuItem>
                        <MenuItem value="Temp sensor 01">Temp sensor 01</MenuItem>
                        <MenuItem value="Gateway Hub 12">Gateway Hub 12</MenuItem>
                        <MenuItem value="Smart Light 45">Smart Light 45</MenuItem>
                        <MenuItem value="Security Cam 08">Security Cam 08</MenuItem>
                    </TextField>
                    <TextField select value={time} onChange={(e) => setTime(e.target.value)} style={{ width: isMobile ? "300px" : "180px" }}>
                        <MenuItem value="Time Range">Time Range</MenuItem>
                        <MenuItem value="Last 1 Hours">Last 1 Hours</MenuItem>
                        <MenuItem value="Last 6 Hours">Last 6 Hours</MenuItem>
                        <MenuItem value="Last 24 Hours">Last 24 Hours</MenuItem>
                        <MenuItem value="Last 7 Days">Last 7 Days</MenuItem>
                    </TextField>
                    <Box display="flex" gap={isMobile ? 2 : 4}>
                        <Button style={{ backgroundColor: "blue", color: "white", height: "50px" }} ><LocationOn /> Show on Map</Button>

                        <Button style={{ backgroundColor: "white", color: "black", height: "50px", border: "1px solid black", paddingLeft: "0.5rem", paddingRight: "0.5rem" }} ><FileDownload /> Export Data</Button>
                    </Box>

                </Box>
            </Card>

            <Grid container spacing={2} mt={4}>
                {/* LIVE SENSOR DATA */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ p:isMobile ? 3 : 2, borderRadius: 4, height: "380px", width: isMobile ? "100%" : "250px" }}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography fontWeight={600}>Live Sensor Data</Typography>
                            <Chip label="LIVE" color="success" size="small" />
                        </Stack>

                        {sensorData.map((item, index) => (
                            <SensorItem key={index} {...item} />
                        ))}
                    </Card>
                </Grid>

                {/* REMOTE ACTIONS */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ p:isMobile ? 3 : 2, borderRadius: 4, height: "380px", width: isMobile ? "100%" : "250px" }}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography fontWeight={600}>Remote Actions</Typography>
                        </Stack>

                        <List>
                            {actionData.map((item, index) => (
                                <ActionItem
                                    key={index}
                                    {...item}
                                    last={index === actionData.length - 1}
                                />
                            ))}
                        </List>
                    </Card>
                </Grid>

                {/* DEVICE LOCATION */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ p:isMobile ? 3 : 2, borderRadius: 4, height: "380px", width: isMobile ? "100%" : "250px" }}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography fontWeight={600}>Device Location</Typography>
                            <Button size="small"><Fullscreen /></Button>
                        </Stack>

                        <Box
                            sx={{
                                bgcolor: "#f3f4f6",
                                p: 3,
                                borderRadius: 4,
                                textAlign: "center",
                            }}
                        >
                            <Chip label="Signal: -67 dBm" />

                            <Avatar
                                sx={{
                                    bgcolor: "#e0ecff",
                                    color: "#2563eb",
                                    width: 56,
                                    height: 56,
                                    mx: "auto",
                                    my: 2,
                                }}
                            >
                                <LocationOn />
                            </Avatar>

                            <Typography fontWeight={600}>
                                Building A - Floor 3
                            </Typography>
                            <Typography fontSize={14} color="text.secondary">
                                Room 315, North Wing
                            </Typography>
                            <Typography fontSize={13} color="text.secondary" mt={1}>
                                Lat: 40.7128, Lng: -74.0060
                            </Typography>

                            <Chip label="Online" color="success" sx={{ mt: 2 }} />
                        </Box>
                    </Card>
                </Grid>
            </Grid>

            <Box
                mt={2}
                px={2}
                py={2}
                display={isMobile ? "flex-wrap" : "flex"}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid #e5e7eb"
            >
                <Box display="flex" alignItems="center" gap={2} marginBottom={2}>
                    <Typography fontSize="18px" fontWeight={600}>
                        Command History
                    </Typography>
                    <Chip label="Last 24 hours" size="small" />
                </Box>

                <Box display="flex" gap={isMobile ? 8: 4}>
                    <Button style={{ backgroundColor: "white", color: "black", height: "30px", border: "1px solid black", }} ><FilterListAlt />Filter</Button>

                    <Button style={{ backgroundColor: "white", color: "black", height: "30px", border: "1px solid black", paddingLeft: "0.5rem", paddingRight: "0.5rem" }} ><FileDownload /> Export</Button>
                </Box>
            </Box>
            <TableContainer
                sx={{
                    overflowX: "auto",
                    marginTop: "1rem",
                    maxWidth: "100%",
                    width: isMobile ? '21.875rem' : 'auto'
                }}
            >
                <Table sx={{ minWidth: isMobile ? '15.625rem' : "40.625rem" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell><b>TIMESTAMP</b></TableCell>
                            <TableCell><b>COMMAND</b></TableCell>
                            <TableCell><b>USER </b></TableCell>
                            <TableCell><b>STATUS</b></TableCell>
                            <TableCell><b>RESPONSE TIME</b></TableCell>
                            <TableCell align="center"><b>ACTIONS</b></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {logs.map((log, index) => (
                            <TableRow key={index} hover>
                                <TableCell>{log.timestamp}</TableCell>

                                <TableCell>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        {log.icon}
                                        <Typography fontSize="14px">{log.type}</Typography>
                                    </Box>
                                </TableCell>

                                <TableCell>
                                    <Box display="flex" alignItems="center" gap={1.5}>
                                        <Typography fontSize="14px">{log.user}</Typography>
                                    </Box>
                                </TableCell>

                                <TableCell style={{ color: log.color }}>{log.status}</TableCell>
                                <TableCell>{log.ResponseTime}</TableCell>

                                <TableCell align="center">
                                    <IconButton>
                                        <Visibility />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>
    )
}

export default Diagnostics